import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { RefillItemsForStorekeeper } from "../models/stock/refill-items-for-storekeeper.model";
import { NewRequestDevice } from "../models/request/new-request/new-request-device";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { WarehouseSenderRecipientData } from "../models/stock/warehouse-sender-recipient-data.model";

@Injectable()
export class WarehouseStockService extends DataService<any, any> {

    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'warehouse-stocks';
    }

    public getRefilItemsForStorekeeper(requestId: number, userId?: number, warehouseId: number = null): Observable<RefillItemsForStorekeeper> {
        return this.getQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/refill-items-for-storekeeper?requestId=${requestId}&userId=${userId}&warehouseId=${warehouseId}`);
    }

    public getRefilItemsForStorekeeperPersonalWarehouse(requestId: number, userId?: number, warehouseId: number = null): Observable<RefillItemsForStorekeeper> {
        return this.getQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/refill-items-for-storekeeper-personal-warehouse?requestId=${requestId}&userId=${userId}&warehouseId=${warehouseId}`);
    }

    public issueItems(requestId: number, requestDevices: NewRequestDevice[], senderWarehouseId: number): Observable<ActionDataResult<any>> {
        return this.postQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/issue-items`, {requestId, requestDevices, senderWarehouseId});
    }

    public issueItemsPersonalWarehouse(requestId: number, requestDevices: NewRequestDevice[], senderWarehouseId: number): Observable<ActionDataResult<any>> {
        return this.postQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/issue-items-personal-warehouse`, {requestId, requestDevices, senderWarehouseId});
    }

    public receiveItems(requestId: number): Observable<ActionDataResult<any>> {
        return this.postQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/receive-items`, {requestId});
    }

    public getWarehouseSenderRecipientData(requestId: number, storekeeperUserId: number): Observable<WarehouseSenderRecipientData> {
        return this.getQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/warehouse-sender-recipient-data?requestId=${requestId}&storekeeperUserId=${storekeeperUserId}`);
    }
}